<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
      ]"
    />

    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>구분</div>
        <div class="flex gap-2">
          <radio-group v-model="form.구분" flex :items="['도급', '용역', '위탁', '기타']" style="height: 37.59px;"/>
          <div v-if="form.구분 === '기타'" class="">
            <p v-if="isPrint" class="print-input">{{ form.구분_기타 }}</p>
            <ml-input v-else v-model="form.구분_기타" />
          </div>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>사업내용</div>
        <p v-if="isPrint" class="print-input">{{ form.사업내용 }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.사업내용" />
      </div>
      <div>
        <div>수탁인</div>
        <p v-if="isPrint" class="print-input">{{ form.수탁인 }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.수탁인" />
      </div>
    </div>

    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 중대산업재해 부서별 점검결과</h5>
      </div>
      <table class="mt-4">
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
          <col width="380" />
        </colgroup>
        <thead>
          <tr>
            <th>의무이행 점검 사항</th>
            <th>부서점검</th>
            <th>중대재해예방팀</th>
            <th>비고 및 조치요구사항</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in form.inspectList" :key="index">
            <th>
              <span class="mr-1">{{ ++index }}.</span>
              <span v-html="item.content.replace(/\n/g, '<br>')" />
            </th>
            <td>
              <p v-if="isPrint">{{ item.부서점검 }}</p>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="item.부서점검">
                <vs-select-item v-for="(option, optionIndex) in ['적정', '미흡', '해당없음']" :key="`부서점검_${index}_${optionIndex}`" :text="option" :value="option" />
              </vs-select>
            </td>
            <td>
              <p v-if="isPrint">{{ item.중대재해예방팀 }}</p>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="item.중대재해예방팀">
                <vs-select-item v-for="(option, optionIndex) in ['적정', '미흡', '해당없음']" :key="`중대재해예방팀_${index}_${optionIndex}`" :text="option" :value="option" />
              </vs-select>
            </td>
            <td>
              <ml-input v-if="!isPrint" v-model="item.비고" class="w-full" />
              <p v-else>{{ item.비고 }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "@/views/boards/single-page/1079/inspectData";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    SignField,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectList: inspectData.inspectTable,
        구분: "",
        구분_기타: "",
        사업내용: "",
        수탁인: "",
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th,
    td {
      font-size: 14px;
      font-weight: 500;

      text-align: center;
      border: 1px solid #cdcdcd;
      padding: 15px;
    }

    th {
      background: #f9f9f9;
    }
  }
  tbody {
    th {
      font-size: 14px;
      font-weight: 500;

      text-align: start;
      padding: 15px;
    }

    td {
      padding: 5px;
    }

    th,
    td {
      border: 1px solid #cdcdcd;
    }
  }
}
</style>
